import React from "react";
import Indentification from "../../../../elements/Indentification";
import { initialsValue } from "../../../../../helpers";
import { lngDetect } from "../../../../../helpers/lngDetect";
import Button from "../../../../form/Button";

const ChatHeader = ({ info, setSelectedChat }) => {
  return (
    <div className="flex items-center px-5 py-4 bg-white rounded-tr-lg shadow-lg border-b border-gray-200">
      <div className="flex items-center mr-auto">
        <div className="mr-2">
        <button type="button" className="w-10 aspect-square flex items-center justify-center text-2xl overflow-hidden block lg:hidden" onClick={() => setSelectedChat(false)}>
          <i className="fa-light fa-arrow-left"></i>
        </button>
      </div>
        <div className="flex-none w-12 h-12 mr-1 image-fit">
          <Indentification
            image={info?.referenceInfo?.gallery?.url}
            initial={initialsValue(lngDetect(info?.referenceInfo?.title))}
            size="lg"
          />
        </div>
        <div className="ml-2 overflow-hidden">
          <div className="text-base font-medium">
            {lngDetect(info?.referenceInfo?.title)}
          </div>
          {/* <div className="text-slate-500">Online</div> */}
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
